import ES from './es/common.json';
import EN from './en/common.json';

export default {
  es: ES,
  en: EN,
};
